import CookiesJS from 'cookies-js';

/**
 * Передаёт данные авторизованного пользователя во встроенный чат talk.me,
 * чтобы оператор видел, кто именно ему пишет.
 *
 * Запускается на каждой странице (бандл подключён сквозно). Если пользователь
 * не авторизован или на странице нет виджета talk.me — тихо завершается.
 *
 * Идентификация в talk.me — вспомогательная: эти данные клиент технически
 * может подменить. Для надёжной привязки диалога к аккаунту talk.me
 * поддерживает секретный TalkMeSetup.clientId (требует доработки бэкенда
 * и настройки до загрузки виджета, здесь не делается).
 */
export async function initTalkMe($, apiClient) {
    try {
        // Виджета нет на лендинге и других лейаутах без партиала talkme.
        if (typeof window.TalkMe !== 'function') {
            return;
        }

        const authToken = CookiesJS.get('auth_token');
        // Не авторизован (login / register / лендинг) — идентифицировать некого.
        if (!authToken) {
            return;
        }

        const user = await apiClient.getSelf(authToken);
        if (!user || !user._id) {
            return;
        }

        const fullName = [user.name, user.surname]
            .filter(Boolean)
            .join(' ')
            .trim();

        // name / email / phone — стандартные поля talk.me setClientInfo.
        // Произвольные поля (вроде ID пользователя) передаются только внутри custom.
        const clientInfo = {
            custom: { 'ID пользователя': String(user._id) },
        };
        if (fullName) clientInfo.name = fullName;
        if (user.email) clientInfo.email = user.email;
        if (user.phone) clientInfo.phone = user.phone;

        // Метод безопасно вызывать и до полной загрузки виджета — talk.me
        // ставит вызовы в очередь так же, как это делал Chatra.
        window.TalkMe('setClientInfo', clientInfo);

        // След в консоли: без него непонятно, чья сторона молчит —
        // наша страница данные не отправила или чат их не показал
        // (разбор 17.10). Печатаем имена полей и идентификатор,
        // без самих контактов: консоль открывают и при посторонних.
        console.info('TalkMe: данные клиента отправлены',
            { поля: Object.keys(clientInfo), id: String(user._id) });
    } catch (error) {
        // Идентификация вспомогательная — не должна ломать страницу.
        console.error('TalkMe integration failed', error);
    }
}
